import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  addToCart,
  addToWish,
  removeFromWish,
  addToCompare,
  removeFromCompare,
  changeComment,
} from '../actions/wishCompareCart';
import { withTranslation } from 'react-i18next';
import {
  getsItemData,
  changeSelect,
  plusCartCount,
  minusCartCount,
  updateItemCount
} from '../actions/item';
import i18n from 'i18next';
import Footer from './footer';
import { config } from '../config';
import loader from '../images/loader.svg';
import defImage from '../images/not-image.png';

import Select from 'react-select';
import Breadcrumb from './breadcrumbs';
import favIcon from '../images/fav_icon.svg';
import compareIcon from '../images/compare_icon.svg';
import ProductsRelated from './productsRelated';
import ProductsHistory from './productsHistory';
import FsLightbox from "fslightbox-react";
import UIkit from 'uikit';
/**
 * Just a wrapper under list items
 *
 */
class PrItem extends Component {
  /**
   *
   * @type {{isShowLoader: *, categoryData: {number, private, static, extends, public, protected, string, bool, constructor, interface, any}, list: string | f.elements.object | Object | CKEDITOR.tools.object | {findKey, merge} | number, orderingData: {number, private, static, extends, public, protected, string, bool, constructor, interface, any}}}
   */
  static propTypes = {
    item: PropTypes.object,
    showItemLoader: PropTypes.bool,
    keysAllowed: PropTypes.any,
    isShowLoaderMenu: PropTypes.bool,
    isChangeUrl: PropTypes.bool,
    urlForChange: PropTypes.string,
    wishData: PropTypes.object,
    cartData: PropTypes.object,
    compareData: PropTypes.object,
    isShowCompareCartWishLoader: PropTypes.bool,
    countProductsToAdd: PropTypes.number,
    ldjson: PropTypes.object,
    commentsItems: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.state = {showLightbox: false, lightboxImages: [], lightboxImagesIndex: 1 };
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.urlForChange !== null &&
      prevProps.urlForChange !== this.props.urlForChange
    ) {
      this.props.history.replace(this.props.urlForChange);
    }
    
  }

  prepareDropdowns = (json, images) => {
    var dataConverted = Object.keys(json).map((itVal) => {
      return {
        value: json[itVal].id,
        label: (
          <div>
            <img
              className='product-prop__image uk-margin-small-right'
              src={
                config.assetsPrfix +
                'img/products/min_' +
                images[json[itVal].id]
              }
              alt={json[itVal].name}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = defImage;
              }}
            />
            {json[itVal].name}
          </div>
        ),
      };
    });
    return dataConverted;
  };

  /**
   * component wil receive props (use for routing on current component)
   *
   * @param nextProps
   */
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.match.params.category !== this.props.match.params.category ||
      nextProps.match.params.id !== this.props.match.params.id
    ) {
      this.props.getItemData(
        nextProps.match.params.category,
        nextProps.match.params.id
      );
    }
    this.lightboxImages();
  }

  /**
   *
   */
  componentDidMount() {
    this.props.getItemData(
      this.props.match.params.category,
      this.props.match.params.id
    );
    
  }

  handleLightbox(index){
    this.setState({showLightbox: !this.state.showLightbox});
    this.setState({lightboxImagesIndex: index+1})
  }

  lightboxImages () {
    const images = [];
    if(this.props.item.goodItem !=undefined && Object.keys(this.props.item.goodItem).length > 0){
      Object.keys(this.props.item.goodItem.images).map(
        (itm, key) =>
            images.push(config.assetsPrfix +'img/products/' + this.props.item.goodItem.images[itm])
          );
      
      this.setState({lightboxImages: images});
    }
 
      
  }
  validateCountInput(e){
    if (e.target.validity.valid){
      this.props.updateItemCount(e);
    }else{
     UIkit.notification({'message':this.props.t("msg_plz_put_valid_count"), 'status':'danger'});
    }
  }
  render() {
    const { t } = this.props;
    const customStyles = {
      control: () => ({
        // none of react-select's styles are passed to <Control />
        display: 'flex',
        borderRadius: '0px',
        height: '100%',
        width: '100%',
      }),
    };
    return (
      <div>
        <header>
          <Helmet>
            <meta charSet='utf-8' />
            <title>
              {this.props.item.goodItem !== undefined
                ? this.props.item.goodItem[`name${this.ucfirst(i18n.language)}`]
                : ''}
            </title>
            <meta property='og:type' content='product.item' />
            <meta
              property='og:title'
              content={
                this.props.item.goodItem !== undefined
                  ? this.props.item.goodItem[
                      `name${this.ucfirst(i18n.language)}`
                    ]
                  : ''
              }
            />
            <meta
              property='og:url'
              content={
                this.props.item.goodItem !== undefined
                  ? this.props.location.pathname
                  : ''
              }
            />
            <meta
              property='og:image'
              content={
                this.props.item.goodItem !== undefined
                  ? config.assetsPrfix +
                    'img/products/' +
                    this.props.item.goodItem['mainImage']
                  : ''
              }
            />
            <meta property='product:condition' content='new' />
            <meta
              property='product:availability'
              content={
                this.props.item.goodItem !== undefined
                  ? this.props.item.goodItem['isInStock'] === 1
                    ? 'in stock'
                    : ''
                  : ''
              }
            />
            <meta
              property='product:price:amount'
              content={
                this.props.item.goodItem !== undefined
                  ? this.props.item.goodItem['priceType1']
                  : ''
              }
            />
            <meta
              property='product:price:currency'
              content={
                this.props.item.goodItem !== undefined
                  ? this.props.item.curName
                  : ''
              }
            />
            <meta
              property='product:retailer_item_id'
              content={
                this.props.item.goodItem !== undefined
                  ? this.props.item.goodItem['id']
                  : ''
              }
            />
            <script className='structured-data-list' type='application/ld+json'>
              {this.props.ldjson}
            </script>
          </Helmet>
        </header>
        <div>
          <div className={this.props.showItemLoader ? '' : 'uk-hidden'}>
            <div className='loader-overlay  uk-position-fixed uk-position-z-index'>
              <div className='uk-position-center'>
                <img
                  className='loader-img'
                  src={loader}
                  uk-svg=''
                  alt={'loading...'}
                />
              </div>
            </div>
          </div>
        </div>
        {Object.keys(this.props.item).length === 0 ? (
          <div></div>
        ) : (
          <div className=' uk-container '>
            <Breadcrumb
              breadcrumbs={
                this.props.item.goodItem.categories.breadcrumbs.breadcrumbs
              }
            />
                    
            <div className='uk-grid-medium' uk-grid=''>
              <div className='product uk-width-1-2@m uk-child-width-1-1 uk-flex uk-flex-wrap'>
                <div className='product-image'>
                  
              
                      <div
                        className='product-images__main-link uk-flex uk-flex-middle uk-flex-center'
                      
                      >
                        <img
                          className='product-images__main'
                          src={
                            this.props.item.goodItem['mainImage']
                              ? config.assetsPrfix +
                                'img/products/' +
                                this.props.item.goodItem['mainImage']
                              : defImage
                          }
                          alt={
                            this.props.item.goodItem[
                              `name${this.ucfirst(i18n.language)}`
                            ]
                          }
                          onClick={() => this.handleLightbox(0)}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = defImage;
                          }}
                        />
                      </div>
                   
                  
                </div>
               
                <FsLightbox
                  toggler={this.state.showLightbox}
                  sources={this.state.lightboxImages}
                  slide={this.state.lightboxImagesIndex}
                />
                <div
                  className='uk-position-relative uk-visible-toggle uk-light'
                  tabindex='-1'
                  uk-slider=''
                >
                  <ul
                    className='uk-slider-items uk-child-width-1-3 uk-child-width-1-5@s uk-grid'
                 
                  >
                    {Object.keys(this.props.item.goodItem.images).map(
                      (itm, key) =>
                        this.props.item.goodItem.images[itm] && (
                          <>
                            <li className='uk-text-center' onClick={() => this.handleLightbox(key)}>
                             
                                <img
                                  className='product-lightbox__image'
                                  src={
                                    config.assetsPrfix +
                                    'img/products/minB_' +
                                    this.props.item.goodItem.images[itm]
                                  }
                                  alt={
                                    this.props.item.goodItem[
                                      `name${this.ucfirst(i18n.language)}`
                                    ]
                                  }
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = defImage;
                                  }}
                                />
                              
                            </li>
                          </>
                        )
                    )}
                  </ul>
                  <a
                    className='uk-position-center-left uk-position-small'
                    href='#'
                    uk-slidenav-previous=''
                    uk-slider-item='previous'
                  ></a>
                  <a
                    className='uk-position-center-right uk-position-small'
                    href='#'
                    uk-slidenav-next=''
                    uk-slider-item='next'
                  ></a>
                </div>
              </div>
              <div className='uk-width-1-2@m'>
                <h1 className='product-name'>
                  {
                    this.props.item.goodItem[
                      `name${this.ucfirst(i18n.language)}`
                    ]
                  }
                </h1>
                <div className='product-block uk-flex uk-flex-between uk-flex-middle '>
                  <div className='product__price uk-text-bold'>
                    {t('item.price')}:
                    <span className='product__price--value'>
                      {' '}
                      {this.props.item.price1 == 0.01 ? t('item.priceSpecify') : `${this.props.item.price1} грн.`}
                    </span>
                  </div>
                  {this.props.item.price1 < this.props.item.price2 &&
                  this.props.item.goodItem.isDiscount ? (
                    <div>
                      <span className='uk-text-bold'>Price old:</span>
                      <s>{this.props.item.price2} грн.</s>
                    </div>
                  ) : (
                    ''
                  )}
                  <div>
                    <span className='uk-text-bold'>{t('item.sku')}:</span>{' '}
                    {this.props.item.goodItem.article}
                  </div>
                </div>
                
                {/* <div className="product-block uk-margin uk-flex uk-flex-between uk-flex-middle">
                                        <span
                                            className="uk-text-bold">{t('item.brandMadeIn')}:</span>
                                        <span
                                            className="uk-text-bold">{this.props.item.goodItem.brand}</span>
                                    </div> */}
                
                  {this.props.isFinded === false
                    ? Object.keys(this.props.item.allowedProperties).map(
                        (itm) => (
                          <div className='product-block uk-margin'>
                          <div className='uk-flex uk-flex-middle '>
                            <span className='uk-text-bold uk-width-medium uk-display-block'>
                              {this.props.item.allowedProperties[itm]['name']} :
                            </span>
                            <Select
                              className={'uk-select uk-width-medium@s'}
                              styles={customStyles}
                              options={this.prepareDropdowns(
                                this.props.item.allowedProperties[itm].values,
                                this.props.item.imagesFilter
                              )}
                              components={{
                                IndicatorSeparator: () => null,
                                IndicatorsContainer: () => null,
                              }}
                              value={this.props.item.filtersItemGroupped[itm]}
                              isSearchable={true}
                              onChange={(e) =>
                                this.props.changeSelect(
                                  e,
                                  itm,
                                  this.props.item.goodItem.mainProductId != null
                                    ? this.props.item.goodItem.mainProductId.id
                                    : this.props.item.goodItem.id,
                                  this.props.match.params.category
                                )
                              }
                            />
                          </div>
                          </div>
                        )
                      )
                    : Object.keys(this.props.item.filterAllowedAll).map(
                        (itm) => (
                          <div className='product-block uk-margin'>
                          <div className='uk-flex uk-flex-middle '>
                            <span className='uk-text-bold uk-width-medium uk-display-block'>
                              {this.props.item.filterAllowedAll[itm]['name']}
                            </span>
                            <Select
                              className='uk-select uk-width-medium@s'
                              options={this.prepareDropdowns(
                                this.props.item.filterAllowedAll[itm].values,
                                this.props.item.imagesFilter
                              )}
                              styles={customStyles}
                              components={{
                                IndicatorSeparator: () => null,
                                IndicatorsContainer: () => null,
                              }}
                              value={
                                this.props.item.preselectedFiltersValueses[itm]
                              }
                              isSearchable={true}
                              onChange={(e) =>
                                this.props.changeSelect(
                                  e,
                                  itm,
                                  this.props.item.productMain.id,
                                  this.props.match.params.category
                                )
                              }
                            />
                          </div>
                          </div>
                        )
                      )}
                  {/* <div className="uk-margin uk-flex uk-flex-middle ">
                                            <span
                                                className="uk-text-bold uk-width-medium uk-display-block">{t('item.comment')}:</span>
                                            <input className="uk-input  uk-width-medium@s"
                                                   onChange={e => this.props.changeComment(e, this.props.item.goodItem.id)}
                                                   name={'comment'} type={'text'}
                                                   value={this.props.commentsItems[this.props.item.goodItem.id] !== undefined ? this.props.commentsItems[this.props.item.goodItem.id] : ''}/>
                                            <input onChange={e => this.props.changeComment(e,this.props.item.goodItem.id)} name={'comment'} type={'text'} value={this.props.commentsItems} />
                                        </div> */}
                <div className='product-stock-label'>{t(this.props.item.stockInfo)}</div>
                <div className='product-block uk-position-relative'>
                  <div
                    className={
                      this.props.isShowCompareCartWishLoader ? '' : 'uk-hidden'
                    }
                  >
                    <div className='uk-overlay-default uk-position-cover uk-position-z-index'>
                      <div className='loader-wrap__small uk-position-center'>
                        <img src={loader} uk-svg='' alt={'loading...'} />
                      </div>
                    </div>
                  </div>
                  {Object.keys(this.props.wishData).length > 0 ? (
                    <div>
                      <div className='uk-flex uk-flex-middle uk-margin-top'>
                        <div className='product-block__qty uk-position-relative uk-margin-small-right'>
                          <span
                            className='product-block__qty-control  uk-position-center-left'
                            onClick={this.props.minusCartCount}
                          >
                            -
                          </span>
                          <input
                           onChange={e =>{
                              this.validateCountInput(e);
                           }}
                            className='product-block__qty-inp uk-input uk-text-center'
                            type='text'
                            pattern="[0-9]*"
                            value={this.props.countProductsToAdd}
                          />
                          <span
                            className='product-block__qty-control uk-position-center-right'
                            onClick={this.props.plusCartCount}
                          >
                            +
                          </span>
                        </div>

                        {Object.keys(this.props.wishData).length &&
                        Object.keys(this.props.compareData).length ? (
                          <div
                            className={
                              'uk-flex uk-flex-middle uk-width-medium '
                            }
                          >
                            <button
                              onClick={(e) =>
                                this.props.addToCart(
                                  this.props.item.goodItem.id
                                )
                              }
                              className={`product-addtocart ${!this.props.item.isInStock&&'product-addtocart--disable'} uk-button`}
                              disabled={this.props.item.isInStock?false:true}
                            >
                              {t('item.add_tocart')}
                            </button>
                            <div className='uk-width-1-1 uk-width-1-3@m uk-flex uk-flex-around'>
                              <div
                                className={
                                  this.props.wishData.data !== undefined &&
                                  this.props.wishData.data[
                                    this.props.item.goodItem.id
                                  ] === undefined
                                    ? 'product-wish-btn__active'
                                    : 'product-wish-btn__inactive'
                                }
                                onClick={(e) => {
                                  this.props.wishData.data[
                                    this.props.item.goodItem.id
                                  ] === undefined
                                    ? this.props.addToWish(
                                        this.props.item.goodItem.id
                                      )
                                    : this.props.removeFromWish(
                                        this.props.item.goodItem.id
                                      );
                                }}
                                title={
                                  this.props.wishData.data !== undefined &&
                                  this.props.wishData.data[
                                    this.props.item.goodItem.id
                                  ] === undefined
                                    ? t('item.add_towish')
                                    : t('item.removeToFavorite')
                                }
                              >
                                <img
                                  className='product-block__control-icon'
                                  src={favIcon}
                                  uk-svg=''
                                />
                              </div>

                              <div
                                className={
                                  this.props.compareData.data !== undefined &&
                                  this.props.compareData.data[
                                    this.props.item.goodItem.id
                                  ] === undefined
                                    ? 'product-compare-btn__active'
                                    : 'product-compare-btn__inactive'
                                }
                                onClick={(e) => {
                                  this.props.compareData.data[
                                    this.props.item.goodItem.id
                                  ] === undefined
                                    ? this.props.addToCompare(
                                        this.props.item.goodItem.id
                                      )
                                    : this.props.removeFromCompare(
                                        this.props.item.goodItem.id
                                      );
                                }}
                                title={
                                  this.props.compareData.data !== undefined &&
                                  this.props.compareData.data[
                                    this.props.item.goodItem.id
                                  ] === undefined
                                    ? t('item.add_tocompare')
                                    : t('item.removeToCompare')
                                }
                              >
                                <img
                                  className='product-block__control-icon'
                                  src={compareIcon}
                                  uk-svg=''
                                />
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div>"LOADDDING"</div>
                  )}
                </div>
                <div>
                  <ul
                    className='product-accordion uk-margin-large-top'
                    uk-accordion="multiple: true"
                  >
                    <li className='uk-open'>
                      <a className='uk-accordion-title uk-text-bold' href={'#'}>
                        {t('item.characteristics')}
                      </a>
                      <div className='uk-accordion-content'>
                        <table className='uk-table uk-table-small uk-table-divider'>
                          <tbody>
                            {Object.keys(this.props.item.itemProperties).map(
                              (itip) => (
                                <tr
                                  className='product-accordion__prop-item'
                                  key={itip}
                                >
                                  <td>
                                    {this.props.item.itemProperties[itip].name}
                                  </td>
                                  <td>
                                    {this.props.item.itemProperties[itip].value}
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                    </li>
                    <li className='uk-open'>
                      <a
                        className='uk-accordion-title uk-text-bold '
                        href={'#'}
                      >
                        {t('item.description')}
                      </a>
                      <div className='uk-accordion-content'>
                        <div dangerouslySetInnerHTML={{ __html: this.props.item.goodItem.description }} />
                      </div>
                    </li>
                  </ul>
                </div>
                {Object.keys(this.props.item.relProducts).length > 0 && (
                  <ProductsRelated products={this.props.item.relProducts} />
                )}
              </div>
            </div>
            {this.props.item && this.props.item.goodItem && (
              <ProductsHistory
                productId={this.props.item.goodItem.id}
              ></ProductsHistory>
            )}
          </div>
        )}
        <Footer />
      </div>
    );
  }

  ucfirst = (str) => {
    // Make a string&#039;s first character uppercase
    var f = str.charAt(0).toUpperCase();
    return f + str.substr(1, str.length - 1);
  };
}

const mapStateToProps = (store) => {
  const {
    item,
    showItemLoader,
    isFinded,
    isChangeUrl,
    urlForChange,
    countProductsToAdd,
  } = store.goodItem;
  const { joomlaMenu, isShowLoaderMenu } = store.menu;
  const {
    wishData,
    cartData,
    compareData,
    isShowCompareCartWishLoader,
    commentsItems,
  } = store.wishCompareCart;
  const ldjson = showItemLoader
    ? {}
    : {
        '@context': 'http://schema.org/',
        '@type': 'Product',
        brand: {
          '@type': 'Brand',
          name: item.goodItem.brand,
        },
        name: item.goodItem[`name${ucfirst(i18n.language)}`],
        image:
          config.assetsPrfix + 'img/products/' + item.goodItem['mainImage'],
        description: item.goodItem.description,
        productID: item.goodItem.id,
        offers: {
          '@type': 'Offer',
          priceCurrency: item.curName,
          price: item.goodItem.priceType1,
          itemCondition: 'new',
        },
      };

  return {
    item: item,
    showItemLoader: showItemLoader,
    isFinded: isFinded,
    joomlaMenu,
    isShowLoaderMenu,
    isChangeUrl,
    urlForChange,
    isShowCompareCartWishLoader,
    wishData,
    cartData,
    compareData,
    countProductsToAdd,
    ldjson: JSON.stringify(ldjson),
    commentsItems,
  };
};

const ucfirst = (str) => {
  // Make a string&#039;s first character uppercase
  var f = str.charAt(0).toUpperCase();
  return f + str.substr(1, str.length - 1);
};

const mapDispatchToProps = (dispatch) => {
  return {
    getItemData: (category, id) => {
      dispatch(getsItemData(category, id));
    },

    changeSelect: (item, filterId, itmId, category) => {
      dispatch(changeSelect(itmId, filterId, item.value, category));
    },

    addToCart: (item) => {
      dispatch(addToCart(item));
    },

    addToWish: (item) => {
      dispatch(addToWish(item));
    },

    removeFromWish: (item) => {
      dispatch(removeFromWish(item));
    },

    removeFromCompare: (item) => {
      dispatch(removeFromCompare(item));
    },

    addToCompare: (item) => {
      dispatch(addToCompare(item));
    },

    plusCartCount: () => {
      dispatch(plusCartCount());
    },

    minusCartCount: () => {
      dispatch(minusCartCount());
    },
    updateItemCount: (e) => {
      dispatch(updateItemCount(e.target.value));
    },
    changeComment: (e, itemId) => {
      dispatch(changeComment(e.target.value, itemId));
    },
  };
};

const ProductsItem = withTranslation('translations')(PrItem);
export default connect(mapStateToProps, mapDispatchToProps)(ProductsItem);
